import type React from 'react';
import { FormField, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { TENANT_MAINTENANCE } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function TenantMaintenance({ section, setSectionValues }: Props) {
  function onNoTenantMaintenance(): void {
    setSectionValues({
      [TENANT_MAINTENANCE.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesTenantMaintenance(): void {
    setSectionValues({
      [TENANT_MAINTENANCE.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onTenantMaintenanceDescriptionChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void {
    const { value } = event.currentTarget;

    setSectionValues({ [TENANT_MAINTENANCE.FIELD_NAME.TENANT_MAINTENANCE_DESCRIPTION]: value });
  }

  return (
    <FormField
      required
      label={<Label>Is the tenant required to maintain anything on the property?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesTenantMaintenance}
          noHandler={onNoTenantMaintenance}
          yesActive={section.getFieldValue(TENANT_MAINTENANCE.FIELD_NAME.IS_ENABLED)}
        >
          <FormField
            required
            label={<Label>Provide a description</Label>}
            control={
              <Textarea
                value={section.getFieldValue(TENANT_MAINTENANCE.FIELD_NAME.TENANT_MAINTENANCE_DESCRIPTION)}
                onChange={onTenantMaintenanceDescriptionChange}
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}

TenantMaintenance.description = 'Asks whether or not there are tenant maintenance to do.';

export default TenantMaintenance;
